module.exports = __webpack_public_path__ + "static/gradient-3a82969423d1e0d07c476217127d7e5e.png";